import { connect } from 'react-redux'
import Event from './Event.jsx'
import { getCollaborativeIndexationCreationFields } from 'redux/collaborativeIndexations/selectors'
import { updateCollaborativeIndexationFieldValue } from 'redux/collaborativeIndexations/actions'

const mapDispatchToProps = (dispatch, getState) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value))
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
})

export const EventContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Event)
